import {
  Box,
  Button,
  Dialog,
  IconButton,
  Typography,
  useTheme,
} from '@mui/material';
import { AlertCircle, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const LogoutModal = ({
  openLogoutModal,
  setOpenLogoutModal,
  handleLogout,
}: {
  openLogoutModal: boolean;
  setOpenLogoutModal: (open: boolean) => void;
  handleLogout: () => void;
}) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Dialog
      open={openLogoutModal}
      PaperProps={{ sx: { borderRadius: '16px', p: 1 } }}
    >
      <Box sx={{ position: 'relative', p: 2, minWidth: '280px' }}>
        <IconButton
          aria-label="close"
          onClick={() => setOpenLogoutModal(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.text.disabled,
          }}
        >
          <X size={18} />
        </IconButton>

        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: 1.5,
            pt: 2,
            pb: 1,
          }}
        >
          <AlertCircle
            size={48}
            color={theme.palette.warning.main}
            strokeWidth={1.5}
          />
          <Typography
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontSize: theme.fontSizes.body,
              color: theme.palette.text.primary,
              textAlign: 'center',
            }}
          >
            {t('general.confirmationLogOutMessage')}
          </Typography>
        </Box>

        <Box
          sx={{ display: 'flex', justifyContent: 'center', gap: 1.5, mt: 1 }}
        >
          <Button
            onClick={() => setOpenLogoutModal(false)}
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontSize: theme.fontSizes.body,
              borderRadius: '32px',
              height: '44px',
              px: 3,
              textTransform: 'none',
              bgcolor: theme.palette.text.secondary,
              color: 'white',
              '&:hover': { bgcolor: theme.palette.text.secondary },
              '&:active': { transform: 'scale(0.97)' },
            }}
          >
            {t('general.cancel')}
          </Button>
          <Button
            onClick={handleLogout}
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontSize: theme.fontSizes.body,
              borderRadius: '32px',
              height: '44px',
              px: 3,
              textTransform: 'none',
              bgcolor: theme.palette.error.main,
              color: 'white',
              '&:hover': { bgcolor: theme.palette.error.main },
              '&:active': { transform: 'scale(0.97)' },
            }}
          >
            {t('general.logout')}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};
